import React from 'react';
import './FilterDetails.css';

function FilterDetails({ count }) {
    return (
        <span className="filter-details">{count} Results</span>
    )
}

export default FilterDetails;
